<template>
  <body :class="body_bg">
  <noscript>
    <strong>We're sorry but pdns doesn't work properly without JavaScript enabled. Please enable it to
      continue.</strong>
  </noscript>
  <!-- <div style="width:100%;height:100%;"> -->
  <Manu v-if="showMenu"></Manu>
  <!-- <transition name="fade" mode="out-in"> -->
  <!-- <transition :name="transitionName"> -->
  <router-view/>
  <!-- </transition> -->
  <footer class="text-center">
    <img src="@/assets/img/footer.png" style="height: 40px;">
  </footer>
  <auto-progress/>
  <!-- </div> -->

  </body>
</template>
<script type="text/javascript">

import autoProgress from 'vue-auto-progress'
import Manu from '@/components/Manu'
import { getAllCountyAndArea } from '@/api/place'

export default {
  name: 'app',
  components: {
    autoProgress,
    Manu
  },
  data () {
    return {
      transitionName: ''
    }
  },
  computed: {
    showMenu: function () {
      return this.$route.name !== 'login'
    },
    body_bg: function () {
      // return this.$route.name === 'dashboard' ? 'dashboard_bg' : 'light_bg';
      if (this.$route.name === 'dashboard') {
        return 'dashboard_bg'
      }
      // else if(this.$route.name === 'search'){
      //   return 'search_bg';
      // }
      else {
        return 'light_bg'
      }
    }
  },
  methods: {
    // getAllPlaceData () {
    //   let countys = []
    //   let allAreas = []
    //   let areasOfCounty = {}
    //   getAllCountyAndArea().then(resp => {
    //     for (let i = 0; i < resp.length; i++) {
    //       countys.push({ code: resp[i].code, id: resp[i].id, name: resp[i].name })
    //       allAreas.push(...resp[i].areas)
    //       areasOfCounty[resp[i].code] = resp[i].areas
    //     }
    //     this.$store.commit('SET_COUNTY_CODE_LIST', countys)
    //     this.$store.commit('SET_AREA_CODE_LIST', allAreas)
    //     this.$store.commit('SET_AREA_CODE_FOR_COUNTY', areasOfCounty)
    //   }).catch(error => {
    //     console.error(error)
    //   })
    // }

  },
  watch: {
    $route (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      // this.$toasted.global.pop_success('切换了一下');
    }
  },
  created () {
    // this.getAllPlaceData()
  },
  filters: {}

}
</script>
<style lang="scss">
  @import '/assets/css/global.scss';
  /*路由切换动画*/
  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
    will-change: transform;
    transition: all 500ms;
    position: absolute;
  }

  .slide-right-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  .slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  footer {
    background: #CCCCCC;
    padding: 32px 0;
  }
</style>
